"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _customHistory = _interopRequireDefault(require("../lib/customHistory"));

var _ScrollToTop = _interopRequireDefault(require("./ScrollToTop"));

/**
 * A custom router for use on the client-side.
 *
 * In client-side rendered apps (create-react-app) this router can be used *instead of*
 * React Router's `<BrowserRouter />` component.
 *
 * In isomorphic apps (Razzle apps) this router can be used instead of the
 * `<BrowserRouter />` on the client-side.
 */
var ClientRouter = function ClientRouter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Router, {
    history: _customHistory["default"]
  }, /*#__PURE__*/_react["default"].createElement(_ScrollToTop["default"], null, children));
};

var _default = ClientRouter;
exports["default"] = _default;